<template>
  <div :class="{'popup-event' : getEventPosition}">
    <EventDetail v-if="evenement" :event="evenement" :popup="getEventPosition"/>
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-w-screen" v-else>
      <p class="text-1-8 tw-text-center">Récupération de l'événement</p>
      <v-progress-linear
          class="tw-w-96"
          color="primary accent-4"
          rounded
          height="6"
          indeterminate
      ></v-progress-linear>
    </div>

  </div>
</template>

<script>
import EventDetail from "../components/Events/EventDetail";
import store from "../store";
import eventGql from "@/queries/EventDetail.graphql"
export default {
  name: "EvenementPage",
  data() {
    return {

    }
  },
  components: {EventDetail},
  apollo: {
    evenement: {
      query : eventGql,
      variables() {
        return {
          slug : this.$route.params.slug
        }
      }
    }
  },
  computed: {
    getEventPosition() {
      return store.state.fixedEvent
    }
  },
}
</script>

<style lang="scss" scoped>

</style>